import { CasePermissions, Entity, RenderMode, FavouriteLayoutModel } from 'app/types-shared';
import { CaseResult } from './types-store';
import { UiDefinition } from 'app/infrastructure/ui/types-uidefinition';
import { RiskMatrixDefinition } from 'app/area/case/types-store';
import { LayoutType } from 'app/area/reports/containers/chart/types-store';
import { FieldItem } from 'app/area/reports/types';

export const ACTION = {
  CLEAR_RESULT: 'CASE_LISTING:CLEAR_RESULT',
  RECEIVE_PERMISSIONS: 'CASE_LISTING:RECEIVE_PERMISSIONS',
  REQUEST_UIDEFINITIONS: 'CASE_LISTING:REQUEST_UIDEFINITIONS',
  RECEIVE_UIDEFINITIONS: 'CASE_LISTING:RECEIVE_UIDEFINITIONS',
  RECEIVE_RISKMATRIXDEFINITIONS: 'CASE_LISTING:RECEIVE_RISKMATRIXDEFINITIONS',
  REQUEST_CASES: 'CASE_LISTING:REQUEST_CASES',
  RECEIVE_CASES: 'CASE_LISTING:RECEIVE_CASES',
  REPLACE_CASES: 'CASE_LISTING:REPLACE_CASES',
  REQUEST_REMOVE_ITEM: 'CASE_LISTING:REQUEST_REMOVE_ITEM',
  RECEIVE_REMOVE_ITEM: 'CASE_LISTING:RECEIVE_REMOVE_ITEM',
  FAIL_REMOVE_ITEM: 'CASE_LISTING:FAIL_REMOVE_ITEM',
  FAIL_EXECUTE_FAVOURITE: 'CASE_LISTING:FAIL_EXECUTE_FAVOURITE',
  SET_RENDERMODE: 'CASE_LISTING:SET_RENDERMODE',
  ADD_INSTANCE: 'CASE_LISTING:ADD_INSTANCE',
  CLEAR_INSTANCE: 'CASE_LISTING:CLEAR_INSTANCE',
  REQUEST_LAYOUT_TYPES: 'CASE_LISTING:REQUEST_LAYOUT_TYPES',
  RESPONSE_LAYOUT_TYPES: 'CASE_LISTING:RESPONSE_LAYOUT_TYPES',
  REQUEST_DEFAULT_INCLUDED_FIELDS: 'CASE_LISTING:REQUEST_DEFAULT_INCLUDED_FIELDS',
  RESPONSE_DEFAULT_INCLUDED_FIELDS: 'CASE_LISTING:RESPONSE_DEFAULT_INCLUDED_FIELDS',
  REQUEST_INCLUDED_FIELDS: 'CASE_LISTING:REQUEST_INCLUDED_FIELDS',
  RESPONSE_INCLUDED_FIELDS: 'CASE_LISTING:RESPONSE_INCLUDED_FIELDS',
  REQUEST_ADDITIONAL_FIELDS: 'CASE_LISTING:REQUEST_ADDITIONAL_FIELDS',
  RESPONSE_ADDITIONAL_FIELDS: 'CASE_LISTING:RESPONSE_ADDITIONAL_FIELDS',
  UPDATE_DEFAULT_INCLUDED_FIELDS: 'CASE_LISTING:UPDATE_DEFAULT_INCLUDED_FIELDS',
  REQUEST_LAYOUT_MODEL: 'CASE_LISTING:REQUEST_LAYOUT_MODEL',
  RECEIVE_LAYOUT_MODEL: 'CASE_LISTING:RECEIVE_LAYOUT_MODEL'
};

export class AddInstance {
  public type: string = ACTION.ADD_INSTANCE;

  constructor(public instanceKey: string) { }
}

export class ClearInstance {
  public type: string = ACTION.CLEAR_INSTANCE;

  constructor(public instanceKey: string) { }
}

export class ClearResults {
  public type: string = ACTION.CLEAR_RESULT;

  constructor(public instanceKey: string) { }
}

export class ReceivePermissions {
  public type: string = ACTION.RECEIVE_PERMISSIONS;

  constructor(
    public instanceKey: string,
    public permissions: { [caseNumber: number]: CasePermissions },
    public requestId: number
  ) { }
}

export class RequestUiDefinitions {
  public type: string = ACTION.REQUEST_UIDEFINITIONS;
  constructor(
    public instanceKey: string,
    public uiDefinitions: { caseTypeId: number; caseContextId: number }[],
    public requestId: number
  ) { }
}

export class ReceiveUiDefinitions {
  public type: string = ACTION.RECEIVE_UIDEFINITIONS;
  constructor(
    public instanceKey: string,
    public uiDefinitions: { caseTypeId: number; caseContextId: number; definition: UiDefinition }[],
    public requestId: number
  ) { }
}

export class ReceiveRiskMatrixDefinitions {
  public type: string = ACTION.RECEIVE_RISKMATRIXDEFINITIONS;

  constructor(
    public instanceKey: string,
    public riskMatrixDefinitions: { [caseType: number]: RiskMatrixDefinition },
    public requestId: number
  ) { }
}

export class RequestCases {
  public type: string = ACTION.REQUEST_CASES;

  constructor(public instanceKey: string) { }
}

export class ReceiveCases {
  public type: string = ACTION.RECEIVE_CASES;

  constructor(
    public instanceKey: string,
    public entities: { [primaryKey: string]: Entity[] },
    public caseResults: CaseResult[],
    public totalNumberOfResults: number,
    public requestId: number
  ) { }
}

export class ReplaceCases {
  public type: string = ACTION.REPLACE_CASES;

  constructor(
    public instanceKey: string,
    public entities: { [primaryKey: string]: Entity[] },
    public caseResults: CaseResult[],
    public totalNumberOfResults: number,
    public requestId: number
  ) { }
}

export class RequestRemoveItem {
  public type: string = ACTION.REQUEST_REMOVE_ITEM;

  constructor(
    public instanceKey: string,
    public itemId: number
  ) { }
}
export class ReceiveRemoveItem {
  public type: string = ACTION.RECEIVE_REMOVE_ITEM;

  constructor(
    public instanceKey: string,
    public itemId: number
  ) { }
}
export class FailRemoveItem {
  public type: string = ACTION.FAIL_REMOVE_ITEM;

  constructor(
    public instance: string,
    public itemId: number
  ) { }
}

export class FailExecuteFavourite {
  public type: string = ACTION.FAIL_EXECUTE_FAVOURITE;

  constructor(
    public instanceKey: string,
    public errorsExecuteFailed: string[]
  ) { }
}

export class SetRenderMode {
  public type: string = ACTION.SET_RENDERMODE;

  constructor(
    public instanceKey: string,
    public renderMode: RenderMode
  ) { }
}

export class RequestLayoutTypes {
  public type: string = ACTION.REQUEST_LAYOUT_TYPES;
  constructor(public instanceKey: string) { }
}
export class ResponseLayoutTypes {
  public type: string = ACTION.RESPONSE_LAYOUT_TYPES;
  constructor(public instanceKey: string, public data: LayoutType[]) { }
}

export class RequestDefaultIncludedFields {
  public type: string = ACTION.REQUEST_DEFAULT_INCLUDED_FIELDS;
  constructor(public instanceKey: string) { }
}

export class ResponseDefaultIncludedFields {
  public type: string = ACTION.RESPONSE_DEFAULT_INCLUDED_FIELDS;
  constructor(public instanceKey: string, public data: FieldItem[]) { }
}

export class RequestAdditionalIncludedFields {
  public type: string = ACTION.REQUEST_ADDITIONAL_FIELDS;
  constructor(public instanceKey: string) { }
}

export class ResponseAdditionalIncludedFields {
  public type: string = ACTION.RESPONSE_ADDITIONAL_FIELDS;
  constructor(public instanceKey: string, public data: FieldItem[]) { }
}

export class UpdateDefaultIncludedFields {
  public type: string = ACTION.UPDATE_DEFAULT_INCLUDED_FIELDS;
  constructor(public instanceKey: string, public data: FieldItem[]) { }
}

export class RequestLayoutModel {
  public type: string = ACTION.REQUEST_LAYOUT_MODEL;
  constructor(public instanceKey: string) { }
}

export class ReceiveLayoutModel {
  public type: string = ACTION.RECEIVE_LAYOUT_MODEL;
  constructor(public instanceKey: string, public layoutModel: FavouriteLayoutModel) { }
}
